// App Grid Component
// Displays apps in a responsive grid layout

import { AppCard } from './AppCard';

export function AppGrid({
  projects,
  manager,
  onToggleFavorite,
  onOpenWorkspace,
  onOpenPlayspace,
  onOpenSettings,
  onOpenContextMenu
}) {
  return (
    <div className="projects-grid">
      {projects.map(project => (
        <AppCard
          key={project.id}
          project={project}
          viewMode="grid"
          manager={manager}
          onToggleFavorite={onToggleFavorite}
          onOpenWorkspace={onOpenWorkspace}
          onOpenPlayspace={onOpenPlayspace}
          onOpenSettings={onOpenSettings}
          onOpenContextMenu={onOpenContextMenu}
        />
      ))}
    </div>
  );
}

